import { call, put, takeEvery, } from "redux-saga/effects";

// Crypto Redux States
import { addUser, addcsvbulkusers, getUserList, editUser, userEditStatus, userDelete } from "../../helpers/api";
import { ADD_USERS, GET_USER_LIST, EDIT_USER, EDIT_USER_STATUS, DELETE_USER, ADD_CSV_BULK_USERS } from "./actionTypes";
import { userListResponce } from "./actions";

//Include Both Helper File with needed methods
import { showToast } from "../toast/actions";



/**
 * Generator function that adds a user to the system.
 * @param {Object} payload - The payload object containing the user data and token.
 * @param {Object} success - The success callback function.
 * @param {Object} failure - The failure callback function.
 * @returns None
 */
function* adduser({ payload: { data }, success, failure }) {

  try {
    const responce = yield call(addUser, data)
    if (responce) {
      yield put(showToast({
        message: responce?.message,
        type: 'success'
      }));

      success(responce)
    }

  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }

}

/**
 * Generator function that handles the addition of bulk users from a CSV file.
 * @param {Object} payload - The payload object containing the data to be added.
 * @param {Array} payload.data - The data to be added.
 * @param {Function} success - The success callback function.
 * @param {Function} setter - The setter function to update the state.
 * @returns None
 * @throws {Error} If an error occurs during the addition of bulk users.
 */
function* addcsvbulkuserHandler({ payload: { data }, success, setter }) {

  try {
    const responce = yield call(addcsvbulkusers, data)
    if (responce) {
      success()
      setter(prev => {
        return {
          ...prev,
          title: 'Success',
          ...responce.data
        }
      })
    }

  } catch (error) {
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }

}


/**
 * Generator function that retrieves the user list using the provided token.
 * @param {Object} payload - The payload object containing the token.
 * @param {string} payload.token - The authorization token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* userList({ success, failure }) {

  try {
    const responce = yield call(getUserList)
    if (responce) {
      yield put(userListResponce(responce));
      success(responce)
    }

  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }

}

/**
 * Generator function that handles editing a user.
 * @param {object} payload - The payload object containing the user ID and data to edit.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* edituser({ payload: { id, data }, success, failure }) {

  try {
    const responce = yield call(editUser, id, data)
    if (responce) {
      yield put(showToast({
        message: responce?.message,
        type: 'success'
      }));
      success(responce)
    }

  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }

}

/**
 * Generator function that handles editing the status of a user.
 * @param {object} payload - The payload object containing the id, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* userEditstatus({ payload: { id, data }, success, failure }) {
  try {
    const responce = yield call(userEditStatus, id, data)
    if (responce) {
      yield put(showToast({
        message: responce?.message,
        type: 'success'
      }));
      success(responce)
    }

  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }

}

/**
 * Generator function that handles the deletion of a user.
 * @param {object} payload - The payload object containing the id, data, and token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns None
 */
function* userdelete({ payload: { id }, success, failure }) {
  try {
    const responce = yield call(userDelete, id)
    if (responce) {
      yield put(showToast({
        message: responce?.message,
        type: 'success'
      }));
      success(responce)
    }

  } catch (error) {
    failure(error)
    yield put(showToast({
      message: error?.response?.data?.message,
      type: 'error'
    }));

  }

}

function* User() {
  yield takeEvery(ADD_USERS, adduser);
  yield takeEvery(ADD_CSV_BULK_USERS, addcsvbulkuserHandler);
  yield takeEvery(GET_USER_LIST, userList);
  yield takeEvery(EDIT_USER, edituser);
  yield takeEvery(EDIT_USER_STATUS, userEditstatus);
  yield takeEvery(DELETE_USER, userdelete);

}

export default User;
